<template>
    <div class="cc-home">
        <router-view/>
    </div>
</template>

<script>
import {sendAlsLog} from '@/lib/als.js';
export default {
    name: 'home',
    components: {
    },
    computed: {
    },
    data() {
        return {
        };
    },
    watch: {
        $route() {
            const {params, name} = this.$route;
            this.logUV({params, name});
        }
    },
    methods: {
        logUV(data) {
            const {params, name} = data;
            let log = {
                f1: name + 'UV',
                f2: 'show'
            };
            if (params.type) {
                log = {
                    ...log,
                    f6: params.type
                };
            }
            this.coAlsLog(log);
        },
        coAlsLog(data) {
            const userid = this.$store.state.app.hairuo?.userid;
            const optid = this.$store.state.app.hairuo?.optid;
            const log = {
                ...data,
                f3: userid,
                f14: optid
            };

            return sendAlsLog(log);
        }
    },
    mounted() {
        const {params, name} = this.$route;
        this.logUV({params, name});
    }
};
</script>

<style lang="less" scoped>
</style>
